// Shim for trim-canvas to fix CJS/ESM interop with Rolldown bundler
// The original module uses module.exports with __esModule + default pattern
// that Rolldown doesn't handle correctly
export default function trimCanvas(canvas: HTMLCanvasElement): HTMLCanvasElement {
  const ctx = canvas.getContext('2d');
  if (!ctx) return canvas;

  const w = canvas.width;
  const h = canvas.height;
  const imageData = ctx.getImageData(0, 0, w, h).data;

  const getAlpha = (x: number, y: number) => imageData[(y * w + x) * 4 + 3];

  let top = 0, bottom = h - 1, left = 0, right = w - 1;

  // Find top
  outer1: for (let y = 0; y < h; y++) {
    for (let x = 0; x < w; x++) {
      if (getAlpha(x, y)) { top = y; break outer1; }
    }
  }
  // Find bottom
  outer2: for (let y = h - 1; y >= 0; y--) {
    for (let x = 0; x < w; x++) {
      if (getAlpha(x, y)) { bottom = y; break outer2; }
    }
  }
  // Find left
  outer3: for (let x = 0; x < w; x++) {
    for (let y = 0; y < h; y++) {
      if (getAlpha(x, y)) { left = x; break outer3; }
    }
  }
  // Find right
  outer4: for (let x = w - 1; x >= 0; x--) {
    for (let y = 0; y < h; y++) {
      if (getAlpha(x, y)) { right = x; break outer4; }
    }
  }

  const trimW = right - left + 1;
  const trimH = bottom - top + 1;
  const trimmed = ctx.getImageData(left, top, trimW, trimH);

  canvas.width = trimW;
  canvas.height = trimH;
  ctx.clearRect(0, 0, trimW, trimH);
  ctx.putImageData(trimmed, 0, 0);

  return canvas;
}
